export enum ToastType {
    ErrorToast = 'errorToast',
    SuccessToast = 'successToast',
    InfoToast = 'infoToast'
}
